import { Button, Grid, Typography } from "@mui/material";
import { zodResolver } from "@hookform/resolvers/zod";
import { Editor } from 'primereact/editor';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import showToast from "../../../components/Hot-Toast/showToast";
import { jobDescriptionSchema } from "../../../hooks/validationSchema";
import { customStep, nextStep, update } from "../../../slice/jobSlice";
import { useTMutation } from "../../../utils/useTMutation";

const JobDescription = () => {
    const dispatch = useDispatch();
    const { mutateAsync } = useTMutation("/job/addUpdateJob", "post", (data => { return data }));
    const { jobData, step } = useSelector(state => state.job);
    const appliedAplicants = jobData?.cliniciansInFacilityJobShifts?.length;
    const { control, handleSubmit, formState: { errors }, watch, setValue } = useForm({
        resolver: zodResolver(jobDescriptionSchema),
        defaultValues: {
            JOB_DESCRIPION: jobData?.JOB_DESCRIPION || "",
        }
    });

    const onSubmitNext = async (data) => {
        if (jobData.ID) data.ID = jobData.ID;
        try {
            const response = await mutateAsync({ ...data, ID: jobData?.ID, STEP: jobData.REDIRECT ? 8 : step + 1 });
            if (response.STATUS) {
                if (jobData.REDIRECT) {
                    dispatch(customStep(8))
                } else {
                    dispatch(nextStep())
                }
                dispatch(update({ ...data, "REDIRECT": false }))
            } else {
                showToast("error", data.MESSAGE, 3000);
            }
        } catch (error) {
            console.error("Validation Request failed:", error.message);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };
    return (
        <>
            <Grid container alignItems="center" spacing={1} justifyContent="space-around" px={1} pb={3}>
                <Grid item xs={12} sm={12}>
                    <Typography px={7} variant="h3" className="about-texts">
                        Add Job Description
                    </Typography>
                </Grid>

                <form onSubmit={handleSubmit(onSubmitNext)}>
                    <Grid item mt={1}>
                        <Editor
                            value={watch("JOB_DESCRIPION")}
                            onTextChange={(e) => setValue("JOB_DESCRIPION", e.htmlValue?.toString())}
                            style={{ height: '320px', width: "750px" }}
                        />
                        {errors.JOB_DESCRIPION && (
                            <Typography color="error" variant="body2" mt={1}>
                                {errors.JOB_DESCRIPION.message}
                            </Typography>
                        )}
                    </Grid>

                    <Grid item xs={12} mt={2} sm={6} md={12} lg={12} style={{ justifyContent: "end", display: "flex" }}>
                        <Button
                            className="custombuttons"
                            type="submit"
                        >
                            Finish & Preview
                        </Button>
                    </Grid>
                </form>
            </Grid>
        </>
    );
};

export default JobDescription;
